/* Captions Pro landing (theme version, built from the page by build_theme.py) */
/* Captions Pro landing: lazy-load + autoplay videos only while on screen, and drive the
   Results parallax from the page scroll. Respects reduced-motion. */
(function(){
  if(window.__cplReady)return;window.__cplReady=true;          /* every section loads this file; run once */
  var design=!!(window.Shopify&&window.Shopify.designMode);      /* in the theme editor: no entrance animations */
  var io='IntersectionObserver' in window?new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;
      if(e.isIntersecting){if(!v.getAttribute('src'))v.src=v.dataset.src;var pr=v.play();if(pr&&pr.catch)pr.catch(function(){});}
      else if(!v.paused)v.pause();});},{rootMargin:'250px 0px'}):null;
  function watchVideos(){[].forEach.call(document.querySelectorAll('.cpl video[data-src]'),function(v){
    if(v._cpl)return;v._cpl=1;v.muted=true;v.setAttribute('playsinline','');
    if(io)io.observe(v);else{v.src=v.dataset.src;v.autoplay=true;}});}
  watchVideos();

  /* Results window: pins on screen while its columns scroll in opposite directions.
     Up-columns go from top-aligned to bottom-aligned, down-columns the reverse, so the window
     starts and ends on clean edges. Motion is eased so it glides instead of snapping to the wheel. */
  var walls=[].slice.call(document.querySelectorAll('.cpl-par'));
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  function canStick(el){   /* sticky needs no clipping/scrolling ancestor between it and the page */
    for(var n=el.parentElement;n&&n!==document.body&&n!==document.documentElement;n=n.parentElement){
      var o=getComputedStyle(n);if(/auto|scroll|hidden/.test(o.overflowX+' '+o.overflowY))return false;}
    return true;
  }
  function build(w){       /* split the videos into columns; leftovers go to the up-columns first */
    var grid=w.querySelector('.cpl-par-grid');
    var items=w._items||(w._items=[].slice.call(grid.querySelectorAll('.cpl-vid')));
    var cols=parseInt(getComputedStyle(w).getPropertyValue('--cols'),10)||3;
    var base=Math.floor(items.length/cols),extra=items.length%cols,counts=[],c;
    for(c=0;c<cols;c++)counts.push(base);
    for(c=0;c<cols&&extra>0;c+=2){counts[c]++;extra--;}
    for(c=1;c<cols&&extra>0;c+=2){counts[c]++;extra--;}
    while(grid.firstChild)grid.removeChild(grid.firstChild);
    var k=0;return counts.map(function(n){var col=document.createElement('div');col.className='cpl-par-col';
      for(var j=0;j<n;j++)col.appendChild(items[k++]);grid.appendChild(col);return col;});
  }
  var state=[],raf=0,lastW=0,lastH=0,pend=0;
  function frameH(){return walls.length?walls[0].firstElementChild.clientHeight:0;}
  function layout(){
    pend=0;lastW=window.innerWidth;
    walls=[].slice.call(document.querySelectorAll('.cpl-par')).filter(canStick);
    state=walls.map(function(w){
      w.classList.add('is-live');w.style.height='';
      var cols=build(w),frame=w.firstElementChild,fs=getComputedStyle(frame);
      var inner=frame.clientHeight-parseFloat(fs.paddingTop)-parseFloat(fs.paddingBottom),D=0;
      var data=cols.map(function(col,i){var T=Math.max(0,col.offsetHeight-inner);D=Math.max(D,T);
        return {el:col,T:T,up:i%2===0,cur:null,target:0};});
      if(D<60){w.classList.remove('is-live');cols.forEach(function(col){col.style.transform='';});return null;}
      w.style.height=(frame.offsetHeight+D)+'px';          /* pinned for D px of scrolling */
      return {w:w,cols:data,D:D,top:parseFloat(fs.top)||0};
    });
    lastH=frameH();
    aim(true);
  }
  function aim(snap){
    state.forEach(function(st){
      if(!st)return;
      var p=Math.min(1,Math.max(0,(st.top-st.w.getBoundingClientRect().top)/st.D));   /* 0 pin starts, 1 pin ends */
      st.cols.forEach(function(c){c.target=-(c.up?p:1-p)*c.T;if(snap||c.cur===null)c.cur=c.target;});
    });
    if(!raf)raf=requestAnimationFrame(tick);
  }
  function tick(){
    raf=0;var moving=false;
    state.forEach(function(st){
      if(!st)return;
      st.cols.forEach(function(c){var d=c.target-c.cur;
        if(Math.abs(d)>0.25){c.cur+=d*0.16;moving=true;}else c.cur=c.target;
        c.el.style.transform='translate3d(0,'+c.cur.toFixed(2)+'px,0)';});
    });
    if(moving)raf=requestAnimationFrame(tick);
  }
  var parOn=!reduce;
  if(parOn){
    addEventListener('scroll',function(){aim(false);},{passive:true});
    addEventListener('resize',function(){      /* width, or real height change (svh ignores the phone URL bar) */
      if(!pend&&(window.innerWidth!==lastW||frameH()!==lastH))pend=requestAnimationFrame(layout);});
    if(document.readyState!=='complete')addEventListener('load',layout);
    layout();
  }

  /* scroll reveal, matched to finecut.io (see the entrance-motion CSS): each block fades in and pulls up once as it
     comes into view. Blocks that enter together are staggered .1s, in page order. Skipped with reduced motion. */
  var rvRoot=document;
  if(!design&&document.querySelector('.cpl')&&!reduce&&'IntersectionObserver' in window){
    var rvGroups=[['.cpl .cpl-grid-bg--end > *','cpl-rv--big'],
      ['.cpl .cpl-feat, .cpl .cpl-step, .cpl .cpl-review, .cpl .cpl-plan, .cpl .cpl-langs, .cpl .cpl-story-photo, .cpl .cpl-story','cpl-rv--card'],
      ['.cpl .cpl-acc > details','cpl-rv--row'],
      ['.cpl section > .cpl-pill, .cpl section > h2, .cpl section > .cpl-sub, .cpl section > .cpl-fine, .cpl .cpl-all','cpl-rv--up']];
    var rvEls=[];
    rvGroups.forEach(function(g){[].forEach.call(rvRoot.querySelectorAll(g[0]),function(el){
      if(el.closest('.cpl-hero')||el.classList.contains('cpl-rv'))return;
      el.classList.add('cpl-rv',g[1]);rvEls.push(el);});});
    [].forEach.call(document.querySelectorAll('.cpl'),function(r){r.classList.add('cpl--rv');});
    var rvIO=new IntersectionObserver(function(es){
      var shown=es.filter(function(e){return e.isIntersecting;}).map(function(e){return e.target;});
      shown.sort(function(a,b){return a.compareDocumentPosition(b)&Node.DOCUMENT_POSITION_FOLLOWING?-1:1;});
      shown.forEach(function(el,i){rvIO.unobserve(el);el.style.animationDelay=Math.min(i*.1,.4)+'s';el.classList.add('is-in');
        el.addEventListener('animationend',function(){el.classList.add('is-done');},{once:true});});
    },{rootMargin:'0px 0px -8% 0px'});
    rvEls.forEach(function(el){rvIO.observe(el);});
  }

  /* beta reviews -> $1 plan: a red marker arrow (see .cpl-arrow). Shaped from the layout (offsets, so reveal transforms
     don't skew it): it leaves the first card sideways, bends down the left margin and sweeps into the plan. Each pen
     stroke is an ink ribbon (wobble, pressure, a blob where the pen lands, a lighter lift-off, slightly uneven edges),
     filled with an ink-grain pattern. The drawn part of the ribbon is rebuilt as the pen moves, with a round tip, so it
     draws like a marker. No SVG masks or filters: Safari doesn't repaint those while they animate. */
  var arw=null;
  {
    var NS='http://www.w3.org/2000/svg',arwSec=null,arwPens=[],arwYs=[],arwEY=0,arwQ=0,arwAim=0,arwRaf=0,DS=2,INK=5,inkURL='';
    function mk(tag,at,par){var e=document.createElementNS(NS,tag);for(var k in at)e.setAttribute(k,at[k]);if(par)par.appendChild(e);return e;}
    function docPos(el){var x=0,y=0;for(var n=el;n;n=n.offsetParent){x+=n.offsetLeft;y+=n.offsetTop;}
      return {x:x,y:y,h:el.offsetHeight};}
    function pt(q){return q[0].toFixed(1)+','+q[1].toFixed(1);}
    function bez(c,t){var u=1-t,a=u*u*u,b=3*u*u*t,d=3*u*t*t,e=t*t*t;
      return [a*c[0][0]+b*c[1][0]+d*c[2][0]+e*c[3][0],a*c[0][1]+b*c[1][1]+d*c[2][1]+e*c[3][1]];}
    function trace(segs){       /* cubic segments -> points every DS px along the curve */
      var raw=[],out,carry=0,i,t;
      segs.forEach(function(c,k){for(var j=k?1:0;j<=200;j++)raw.push(bez(c,j/200));});
      out=[raw[0]];
      for(i=1;i<raw.length;i++){var a=raw[i-1],b=raw[i],seg=Math.sqrt((b[0]-a[0])*(b[0]-a[0])+(b[1]-a[1])*(b[1]-a[1]));
        for(t=DS-carry;t<=seg;t+=DS)out.push([a[0]+(b[0]-a[0])*t/seg,a[1]+(b[1]-a[1])*t/seg]);
        carry=seg-(t-DS);}
      if(carry>.5)out.push(raw[raw.length-1]);
      return out;
    }
    function inkTile(){         /* marker ink: red with faint vertical streaks, drawn once into a small tile */
      if(inkURL)return inkURL;
      var lo=document.createElement('canvas'),hi=document.createElement('canvas'),c,im,sd=7,i;
      lo.width=16;lo.height=12;hi.width=64;hi.height=192;c=lo.getContext('2d');im=c.createImageData(16,12);
      for(i=0;i<192;i++){sd=(sd*9301+49297)%233280;im.data[i*4]=255;im.data[i*4+1]=77;im.data[i*4+2]=77;im.data[i*4+3]=Math.round((.8+.2*sd/233280)*255);}
      c.putImageData(im,0,0);c=hi.getContext('2d');c.imageSmoothingEnabled=true;c.drawImage(lo,0,0,64,192);
      return inkURL=hi.toDataURL();
    }
    function pen(pts,seed,lift,g){   /* one marker stroke along pts */
      var n=pts.length,L=(n-1)*DS,lf=[],rt=[],ys=[],cum=[0],len=0,px=0,py=0;
      for(var i=0;i<n;i++){
        var a=pts[Math.max(0,i-1)],b=pts[Math.min(n-1,i+1)],tx=b[0]-a[0],ty=b[1]-a[1],tl=Math.sqrt(tx*tx+ty*ty)||1,s=i*DS;
        tx/=tl;ty/=tl;
        var wob=1.1*Math.sin(s/37+seed)+.55*Math.sin(s/13+seed*2.3);                      /* the hand is not a ruler */
        var w=INK*(1+.08*Math.sin(s/53+seed*1.7)+.05*Math.sin(s/17+seed))                 /* pressure */
          *(1+.32*Math.exp(-s/4))*(1-lift*Math.max(0,1-(L-s)/16));                        /* ink blob on landing, lighter lift-off */
        var jl=w/2+.35*Math.sin(i*12.9898+seed*78.233),jr=w/2+.35*Math.sin(i*39.346+seed*11.135);   /* felt-tip edges */
        var x=pts[i][0]-ty*wob,y=pts[i][1]+tx*wob;
        if(i){len+=Math.sqrt((x-px)*(x-px)+(y-py)*(y-py));cum.push(len);}
        px=x;py=y;ys.push(y);
        lf.push([x-ty*jl,y+tx*jl]);rt.push([x+ty*jr,y-tx*jr]);
      }
      return {ink:mk('path',{'class':'cpl-arrow-ink',fill:'url(#cpl-ink-p)'},g),lf:lf,rt:rt,cum:cum,len:len,ys:ys,f:-1};
    }
    function ribbon(p,f){       /* the part of a stroke drawn so far (f: 0-1), ending in a round pen tip */
      if(f<=0)return '';
      var n=p.lf.length,D=Math.min(1,f)*p.len,k=0,t,tl,tr,i,d,r0,r1;
      while(k<n-2&&p.cum[k+1]<=D)k++;
      t=Math.min(1,Math.max(0,(D-p.cum[k])/Math.max(.001,p.cum[k+1]-p.cum[k])));
      tl=[p.lf[k][0]+(p.lf[k+1][0]-p.lf[k][0])*t,p.lf[k][1]+(p.lf[k+1][1]-p.lf[k][1])*t];
      tr=[p.rt[k][0]+(p.rt[k+1][0]-p.rt[k][0])*t,p.rt[k][1]+(p.rt[k+1][1]-p.rt[k][1])*t];
      r1=Math.sqrt((tl[0]-tr[0])*(tl[0]-tr[0])+(tl[1]-tr[1])*(tl[1]-tr[1]))/2;
      r0=Math.sqrt((p.lf[0][0]-p.rt[0][0])*(p.lf[0][0]-p.rt[0][0])+(p.lf[0][1]-p.rt[0][1])*(p.lf[0][1]-p.rt[0][1]))/2;
      d='M'+pt(p.lf[0]);for(i=1;i<=k;i++)d+='L'+pt(p.lf[i]);
      d+='L'+pt(tl)+'A'+r1.toFixed(2)+','+r1.toFixed(2)+' 0 0 0 '+pt(tr);
      for(i=k;i>=0;i--)d+='L'+pt(p.rt[i]);
      return d+'A'+r0.toFixed(2)+','+r0.toFixed(2)+' 0 0 0 '+pt(p.lf[0])+'Z';
    }
    function arwLayout(){
      arwPens=[];arwYs=[];arw=document.querySelector('.cpl-arrow');if(!arw)return;arwSec=arw.parentNode;
      while(arw.firstChild)arw.removeChild(arw.firstChild);
      arw.classList.remove('is-on');
      var a=document.querySelector('.cpl-review'),b=document.querySelector('.cpl-plan--best');
      if(!a||!b)return;
      var sec=docPos(arwSec),A=docPos(a),B=docPos(b),room=A.x;
      if(room<90||window.innerWidth<1024)return;             /* no margin to draw in */
      var bulge=Math.min(146,room*.62),ax=A.x-sec.x,ay=A.y-sec.y,bx=B.x-sec.x,by=B.y-sec.y;
      var S=[ax-20,ay+A.h*.52],M=[ax-bulge,S[1]+200],E=[bx-28,by+64],dx=E[0]-M[0],C4=[E[0]-dx*.45,E[1]-dx*.3];
      var tx=E[0]-C4[0],ty=E[1]-C4[1],tl=Math.sqrt(tx*tx+ty*ty);tx/=tl;ty/=tl;
      function back(ang,len){var c=Math.cos(ang),si=Math.sin(ang);return [E[0]-len*(tx*c-ty*si),E[1]-len*(tx*si+ty*c)];}
      function arm(p0,p3,bow){var nx=-(p3[1]-p0[1]),ny=p3[0]-p0[0],nl=Math.sqrt(nx*nx+ny*ny);nx*=bow/nl;ny*=bow/nl;
        return [[p0,[p0[0]+(p3[0]-p0[0])/3+nx,p0[1]+(p3[1]-p0[1])/3+ny],[p0[0]+(p3[0]-p0[0])*2/3+nx,p0[1]+(p3[1]-p0[1])*2/3+ny],p3]];}
      var line=trace([[S,[S[0]-(S[0]-M[0])*.55,S[1]],[M[0],M[1]-110],M],[M,[M[0],M[1]+(E[1]-M[1])*.55],C4,E]]);
      var armA=trace(arm(back(.5,36),[E[0]+tx*2.5,E[1]+ty*2.5],2.2)),armB=trace(arm([E[0]-tx,E[1]-ty],back(-.62,31),-1.8));
      var all=line.concat(armA,armB),x0=1e9,y0=1e9,x1=-1e9,y1=-1e9;
      all.forEach(function(q){x0=Math.min(x0,q[0]);y0=Math.min(y0,q[1]);x1=Math.max(x1,q[0]);y1=Math.max(y1,q[1]);});
      x0-=24;y0-=24;x1+=24;y1+=24;var box=[x0,y0,x1-x0,y1-y0];
      arw.setAttribute('viewBox',box.join(' '));
      arw.style.left=x0+'px';arw.style.top=y0+'px';arw.style.width=(x1-x0)+'px';arw.style.height=(y1-y0)+'px';
      var pat=mk('pattern',{id:'cpl-ink-p',patternUnits:'userSpaceOnUse',width:64,height:192},mk('defs',{},arw));
      mk('image',{href:inkTile(),width:64,height:192,preserveAspectRatio:'none'},pat);
      var g=mk('g',{},arw);
      var pl=pen(line,.7,.15,g),pa=pen(armA,2.1,.2,g),pb=pen(armB,4.3,.25,g);
      pl.a=0;pl.b=1;pa.a=1;pa.b=1.5;pb.a=1.5;pb.b=2;arwPens=[pl,pa,pb];
      arwYs=pl.ys;arwEY=E[1];
      arw.classList.add('is-on');
      arwTarget();arwQ=arwAim;arwPaint();
    }
    function arwTarget(){   /* 0-1: the line, 1-2: the arrowhead */
      if(!arwYs.length)return;
      if(reduce){arwAim=2;return;}
      var thr=window.innerHeight*.72-arwSec.getBoundingClientRect().top,n=arwYs.length-1,i=0;
      while(i<=n&&arwYs[i]<=thr)i++;
      if(i===0)arwAim=0;
      else if(i<=n)arwAim=(i-1+Math.max(0,Math.min(1,(thr-arwYs[i-1])/Math.max(.001,arwYs[i]-arwYs[i-1]))))/n;
      else arwAim=1+Math.min(1,Math.max(0,(thr-arwEY)/70));
    }
    function arwPaint(){        /* rebuild only the strokes whose progress changed */
      arwPens.forEach(function(p){var f=Math.min(1,Math.max(0,(arwQ-p.a)/(p.b-p.a)));
        if(Math.abs(f-p.f)<.0005)return;p.f=f;p.ink.setAttribute('d',ribbon(p,f));});
    }
    function arwTick(){     /* eased, so it glides like a pen instead of jumping with the wheel */
      arwRaf=0;var d=arwAim-arwQ;
      if(Math.abs(d)>.001){arwQ+=d*.2;arwRaf=requestAnimationFrame(arwTick);}else arwQ=arwAim;
      arwPaint();
    }
    addEventListener('scroll',function(){arwTarget();if(!arwRaf)arwRaf=requestAnimationFrame(arwTick);},{passive:true});
    addEventListener('resize',arwLayout);
    addEventListener('load',arwLayout);
    if(document.fonts&&document.fonts.ready)document.fonts.ready.then(arwLayout);
    arwLayout();
  }

  /* the hero button glides down to the plans: Choose your plan lands just under the dock. Eased by hand so the long
     trip feels smooth; a wheel, touch or key press hands control straight back. Focus moves to the heading too. */
  function bindUI(){
  [].forEach.call(document.querySelectorAll('.cpl .cpl-jump'),function(btn){
    if(btn._cpl)return;btn._cpl=1;
    btn.addEventListener('click',function(e){
      var sec=document.querySelector(btn.getAttribute('href'));if(!sec)return;
      e.preventDefault();
      var h=sec.querySelector('h2')||sec,root=document.documentElement,from=window.pageYOffset,t0=0,stop=false;
      var gap=(parseFloat(getComputedStyle(root).getPropertyValue('--dock-safe-top'))||96)+24;
      function aimY(){return Math.max(0,h.getBoundingClientRect().top+window.pageYOffset-gap);}
      function done(){['wheel','touchstart','keydown'].forEach(function(ev){removeEventListener(ev,halt);});root.style.scrollBehavior='';
        h.setAttribute('tabindex','-1');h.focus({preventScroll:true});}
      function halt(){stop=true;done();}
      if(reduce){window.scrollTo(0,aimY());done();return;}
      var dur=Math.min(1600,Math.max(700,Math.abs(aimY()-from)*.2));
      root.style.scrollBehavior='auto';                       /* no fight with a theme-wide smooth scroll */
      ['wheel','touchstart','keydown'].forEach(function(ev){addEventListener(ev,halt,{passive:true});});
      requestAnimationFrame(function step(now){
        if(stop)return;if(!t0)t0=now;
        var k=Math.min(1,(now-t0)/dur),ease=k<.5?4*k*k*k:1-Math.pow(-2*k+2,3)/2;
        window.scrollTo(0,from+(aimY()-from)*ease);         /* re-aimed each frame, in case anything above resizes */
        if(k<1)requestAnimationFrame(step);else done();
      });
    });
  });

  /* spotlight borders: every card in the group tracks the cursor, so borders near it light up */
  if(window.matchMedia&&matchMedia('(hover:hover)').matches){
    [].forEach.call(document.querySelectorAll('.cpl-glow-group'),function(g){
      if(g._cpl)return;g._cpl=1;
      var cards=[].slice.call(g.querySelectorAll('.cpl-glow')),px=0,py=0,raf=0;
      function paint(){raf=0;cards.forEach(function(c){var r=c.getBoundingClientRect();
        c.style.setProperty('--mx',(px-r.left)+'px');c.style.setProperty('--my',(py-r.top)+'px');});}
      g.addEventListener('pointermove',function(e){px=e.clientX;py=e.clientY;if(!raf)raf=requestAnimationFrame(paint);},{passive:true});
    });
  }
  }
  bindUI();

  /* The theme's smooth-accordion.js cancels every <summary> click on the page and only re-opens <details> that have an
     .accordion-content child. Ours don't, so the FAQ, "See every feature" and the checkout popup's offer-code box never
     opened. Keep that script from seeing clicks there; the browser's own open/close (and our CSS animation) then works. */
  document.addEventListener('click',function(e){
    if(e.target.closest&&e.target.closest('.cpl summary, [data-capro-checkout] summary'))e.stopPropagation();},true);

  /* theme editor: a section re-rendered, was added, removed or moved. Hook up the new markup and re-measure. */
  if(design){
    var redo=function(){watchVideos();bindUI();if(parOn)layout();arwLayout();};
    document.addEventListener('shopify:section:load',redo);
    document.addEventListener('shopify:section:reorder',redo);
    document.addEventListener('shopify:section:unload',function(){setTimeout(redo,60);});
  }
})();
